/** @jsx jsx */
import { jsx } from '@emotion/react';
import { onSm } from '../../styles/responsive';
import { colors, theme } from '../../theme';
import { Link } from '../Link/Link';
import { IconButton } from './IconButton';

export const SocialButton = ({ link, icon }) => {
  return (
    <Link to={link} target="_blank" rel="noopener noreferrer">
      <IconButton
        css={{
          [onSm]: { width: '30px', height: '30px' }
        }}
        icon={icon}
        background={theme.header.icons.background}
        hoverStroke={colors.primary}
        stroke={colors.font}
      />
    </Link>
  );
};
